import React from 'react'
import { Item } from './Item'

export const List = ({ data = [] }) => {
  return data?.map((agendamento, index) => <Item key={index} agendamento={agendamento} />)
}
